var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    width: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M397.3,512H114.7c-37.205,0-67.474-30.269-67.474-67.474V126.125 c0-37.204,30.269-67.473,67.474-67.473H397.3c37.205,0,67.474,30.269,67.474,67.473v216.641c0,7.681-6.227,13.91-13.91,13.91 c-7.682,0-13.91-6.229-13.91-13.91V126.125c0-21.864-17.789-39.653-39.655-39.653H114.7c-21.866,0-39.655,17.789-39.655,39.653 v318.401c0,21.866,17.789,39.655,39.655,39.655H397.3c21.866,0,39.655-17.789,39.655-39.655v-26.651 c0-7.681,6.227-13.91,13.91-13.91c7.682,0,13.91,6.229,13.91,13.91v26.651C464.774,481.731,434.505,512,397.3,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M450.864,178.208v-52.083c0-29.583-23.981-53.564-53.564-53.564H114.7 c-29.583,0-53.564,23.981-53.564,53.564v52.083H450.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M450.864,192.118H61.137c-7.682,0-13.91-6.229-13.91-13.91v-52.083 c0-37.205,30.269-67.474,67.474-67.474H397.3c37.205,0,67.474,30.269,67.474,67.474v52.083 C464.774,185.89,458.546,192.118,450.864,192.118z M75.047,164.298h361.909v-38.173c0-21.866-17.789-39.655-39.655-39.655H114.7 c-21.866,0-39.655,17.789-39.655,39.655v38.173H75.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M299.348,57.257c0-23.94-19.408-43.348-43.348-43.348c-23.94,0-43.348,19.408-43.348,43.348h-31.341 c-9.867,0-17.867,7.999-17.867,17.867v41.005c0,9.867,7.999,17.867,17.867,17.867h149.379c9.867,0,17.867-7.999,17.867-17.867 V75.124c0-9.867-7.999-17.867-17.867-17.867C330.691,57.257,299.348,57.257,299.348,57.257z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M330.689,147.905H181.312c-17.522,0-31.776-14.255-31.776-31.776V75.124 c0-17.522,14.255-31.776,31.776-31.776h19.14C206.682,18.476,229.225,0,256.001,0s49.319,18.476,55.551,43.348h19.14 c17.522,0,31.776,14.255,31.776,31.776v41.004C362.466,133.65,348.211,147.905,330.689,147.905z M181.312,71.167 c-2.181,0-3.957,1.775-3.957,3.957v41.004c0,2.181,1.775,3.957,3.957,3.957h149.379c2.181,0,3.957-1.775,3.957-3.957V75.124 c0-2.181-1.775-3.957-3.957-3.957h-31.342c-7.682,0-13.91-6.229-13.91-13.91c0-16.232-13.206-29.438-29.44-29.438 s-29.44,13.206-29.44,29.438c0,7.681-6.227,13.91-13.91,13.91C212.65,71.167,181.312,71.167,181.312,71.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M361.94,435.514H150.06c-19.941,0-36.163-16.223-36.163-36.163V180.477 c0-7.681,6.227-13.91,13.91-13.91s13.91,6.229,13.91,13.91v218.873c0,4.601,3.743,8.344,8.344,8.344h211.88 c4.601,0,8.344-3.743,8.344-8.344V234.753c0-7.681,6.227-13.91,13.91-13.91c7.682,0,13.91,6.229,13.91,13.91v164.597 C398.104,419.29,381.881,435.514,361.94,435.514z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.bdc0598fe532527bc3e71ebd55350692.svg";
export { ForwardRef as ReactComponent };